module.exports = __webpack_public_path__ + "media/public/img/chatbot-icon-magpie-e22f890a54729d9ba76924940570f30d.png";